//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * VerifySlide
 * @description 滑块
 * */
import { aesEncrypt } from './../utils/ase';
import { resetSize as _resetSize } from './../utils/util';
import { reqGet, reqCheck } from './../api/index';
//  "captchaType":"blockPuzzle",
export default {
  name: 'VerifySlide',
  props: {
    captchaType: {
      type: String
    },
    type: {
      type: String,
      default: '1'
    },
    // 弹出式pop，固定fixed
    mode: {
      type: String,
      default: 'fixed'
    },
    vSpace: {
      type: Number,
      default: 5
    },
    explain: {
      type: String,
      default: '向右滑动完成验证'
    },
    imgSize: {
      type: Object,
      default: function _default() {
        return {
          width: '310px',
          height: '155px'
        };
      }
    },
    blockSize: {
      type: Object,
      default: function _default() {
        return {
          width: '50px',
          height: '50px'
        };
      }
    },
    barSize: {
      type: Object,
      default: function _default() {
        return {
          width: '310px',
          height: '40px'
        };
      }
    },
    defaultImg: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      secretKey: '',
      // 后端返回的加密秘钥 字段
      passFlag: '',
      // 是否通过的标识
      backImgBase: '',
      // 验证码背景图片
      blockBackImgBase: '',
      // 验证滑块的背景图片
      backToken: '',
      // 后端返回的唯一token值
      startMoveTime: '',
      // 移动开始的时间
      endMovetime: '',
      // 移动结束的时间
      tipsBackColor: '',
      // 提示词的背景颜色
      tipWords: '',
      text: '',
      finishText: '',
      setSize: {
        imgHeight: 0,
        imgWidth: 0,
        barHeight: 0,
        barWidth: 0
      },
      top: 0,
      left: 0,
      moveBlockLeft: undefined,
      leftBarWidth: undefined,
      // 移动中样式
      moveBlockBackgroundColor: undefined,
      leftBarBorderColor: '#ddd',
      iconColor: undefined,
      iconClass: 'icon-right',
      status: false,
      // 鼠标状态
      isEnd: false,
      // 是够验证完成
      showRefresh: true,
      transitionLeft: '',
      transitionWidth: ''
    };
  },
  computed: {
    barArea: function barArea() {
      return this.$el.querySelector('.verify-bar-area');
    },
    resetSize: function resetSize() {
      return _resetSize;
    }
  },
  watch: {
    // type变化则全面刷新
    type: {
      immediate: true,
      handler: function handler() {
        this.init();
      }
    }
  },
  mounted: function mounted() {
    // 禁止拖拽
    this.$el.onselectstart = function () {
      return false;
    };
  },
  methods: {
    init: function init() {
      var _this2 = this;
      this.text = this.explain;
      this.getPictrue();
      this.$nextTick(function () {
        var setSize = _this2.resetSize(_this2); // 重新设置宽度高度
        for (var key in setSize) {
          _this2.$set(_this2.setSize, key, setSize[key]);
        }
        _this2.$parent.$emit('ready', _this2);
      });
      var _this = this;
      window.removeEventListener('touchmove', function (e) {
        _this.move(e);
      });
      window.removeEventListener('mousemove', function (e) {
        _this.move(e);
      });

      // 鼠标松开
      window.removeEventListener('touchend', function () {
        _this.end();
      });
      window.removeEventListener('mouseup', function () {
        _this.end();
      });
      window.addEventListener('touchmove', function (e) {
        _this.move(e);
      });
      window.addEventListener('mousemove', function (e) {
        _this.move(e);
      });

      // 鼠标松开
      window.addEventListener('touchend', function () {
        _this.end();
      });
      window.addEventListener('mouseup', function () {
        _this.end();
      });
    },
    // 鼠标按下
    start: function start(e) {
      e = e || window.event;
      if (!e.touches) {
        // 兼容PC端
        var x = e.clientX;
      } else {
        // 兼容移动端
        var x = e.touches[0].pageX;
      }
      this.startLeft = Math.floor(x - this.barArea.getBoundingClientRect().left);
      this.startMoveTime = +new Date(); // 开始滑动的时间
      if (this.isEnd == false) {
        this.text = '';
        this.moveBlockBackgroundColor = '#337ab7';
        this.leftBarBorderColor = '#337AB7';
        this.iconColor = '#fff';
        e.stopPropagation();
        this.status = true;
      }
    },
    // 鼠标移动
    move: function move(e) {
      e = e || window.event;
      if (this.status && this.isEnd == false) {
        if (!e.touches) {
          // 兼容PC端
          var x = e.clientX;
        } else {
          // 兼容移动端
          var x = e.touches[0].pageX;
        }
        var bar_area_left = this.barArea.getBoundingClientRect().left;
        var move_block_left = x - bar_area_left; // 小方块相对于父元素的left值
        if (move_block_left >= this.barArea.offsetWidth - parseInt(parseInt(this.blockSize.width) / 2) - 2) {
          move_block_left = this.barArea.offsetWidth - parseInt(parseInt(this.blockSize.width) / 2) - 2;
        }
        if (move_block_left <= 0) {
          move_block_left = parseInt(parseInt(this.blockSize.width) / 2);
        }
        // 拖动后小方块的left值
        this.moveBlockLeft = move_block_left - this.startLeft + 'px';
        this.leftBarWidth = move_block_left - this.startLeft + 'px';
      }
    },
    // 鼠标松开
    end: function end() {
      var _this3 = this;
      this.endMovetime = +new Date();
      var _this = this;
      // 判断是否重合
      if (this.status && this.isEnd == false) {
        var moveLeftDistance = parseInt((this.moveBlockLeft || '').replace('px', ''));
        moveLeftDistance = moveLeftDistance * 310 / parseInt(this.setSize.imgWidth);
        var data = {
          captchaType: this.captchaType,
          pointJson: this.secretKey ? aesEncrypt(JSON.stringify({
            x: moveLeftDistance,
            y: 5.0
          }), this.secretKey) : JSON.stringify({
            x: moveLeftDistance,
            y: 5.0
          }),
          token: this.backToken
        };
        reqCheck(data).then(function (res) {
          if ((res === null || res === void 0 ? void 0 : res.repCode) == '0000') {
            _this3.moveBlockBackgroundColor = '#5cb85c';
            _this3.leftBarBorderColor = '#5cb85c';
            _this3.iconColor = '#fff';
            _this3.iconClass = 'icon-check';
            _this3.showRefresh = false;
            _this3.isEnd = true;
            if (_this3.mode == 'pop') {
              setTimeout(function () {
                _this3.$parent.clickShow = false;
                _this3.refresh();
              }, 1500);
            }
            _this3.passFlag = true;
            _this3.tipWords = "".concat(((_this3.endMovetime - _this3.startMoveTime) / 1000).toFixed(2), "s\u9A8C\u8BC1\u6210\u529F");
            var captchaVerification = _this3.secretKey ? aesEncrypt(_this3.backToken + '---' + JSON.stringify({
              x: moveLeftDistance,
              y: 5.0
            }), _this3.secretKey) : _this3.backToken + '---' + JSON.stringify({
              x: moveLeftDistance,
              y: 5.0
            });
            setTimeout(function () {
              _this3.tipWords = '';
              _this3.$parent.closeBox();
              _this3.$parent.$emit('success', {
                captchaVerification: captchaVerification
              });
            }, 1000);
          } else {
            _this3.moveBlockBackgroundColor = '#d9534f';
            _this3.leftBarBorderColor = '#d9534f';
            _this3.iconColor = '#fff';
            _this3.iconClass = 'icon-close';
            _this3.passFlag = false;
            setTimeout(function () {
              _this.refresh();
            }, 1000);
            _this3.$parent.$emit('error', _this3);
            _this3.tipWords = '验证失败';
            setTimeout(function () {
              _this3.tipWords = '';
            }, 1000);
          }
        });
        this.status = false;
      }
    },
    refresh: function refresh() {
      var _this4 = this;
      this.showRefresh = true;
      this.finishText = '';
      this.transitionLeft = 'left .3s';
      this.moveBlockLeft = 0;
      this.leftBarWidth = undefined;
      this.transitionWidth = 'width .3s';
      this.leftBarBorderColor = '#ddd';
      this.moveBlockBackgroundColor = '#fff';
      this.iconColor = '#000';
      this.iconClass = 'icon-right';
      this.isEnd = false;
      this.getPictrue();
      setTimeout(function () {
        _this4.transitionWidth = '';
        _this4.transitionLeft = '';
        _this4.text = _this4.explain;
      }, 300);
    },
    // 请求背景图片和验证图片
    getPictrue: function getPictrue() {
      var _this5 = this;
      var data = {
        captchaType: this.captchaType,
        clientUid: localStorage.getItem('slider'),
        ts: Date.now() // 现在的时间戳
      };
      reqGet(data).then(function (res) {
        if ((res === null || res === void 0 ? void 0 : res.repCode) == '0000') {
          _this5.backImgBase = res.repData.originalImageBase64;
          _this5.blockBackImgBase = res.repData.jigsawImageBase64;
          _this5.backToken = res.repData.token;
          _this5.secretKey = res.repData.secretKey;
          _this5.$store.commit('user/SET_CAPTCHA', {
            captchaVerification: res.repData.captchaVerification,
            secretKey: res.repData.secretKey,
            token: res.repData.token
          });
        } else {
          _this5.tipWords = res === null || res === void 0 ? void 0 : res.repMsg;
        }

        // 判断接口请求次数是否失效
        if ((res === null || res === void 0 ? void 0 : res.repCode) == '6201') {
          _this5.backImgBase = null;
          _this5.blockBackImgBase = null;
        }
      });
    }
  }
};